import { Column } from "../components/Table"
import { standardTreeNamesFormatter } from "./tables/content"

// Child columns have full "Standards: X" labels for table display
// Uses new standardTreeNamesFormatter to parse standardTreeNames field
export const generateStandardColumn = (
  standardFrameworks: string[]
): Column => {
  if (standardFrameworks.length > 0) {
    return {
      label: "Standards",
      name: "standards-group",
      columns: standardFrameworks.map(framework => ({
        label: framework, // Just "ACT", "DSAT" etc. for dropdown
        displayLabel: `Standards: ${framework}`, // Full label for table header
        name: `standards-${framework}`, // Unique name per framework
        sortable: false,
        // Pass framework name to formatter so it knows which standards to display
        formatter: (record, prop) =>
          standardTreeNamesFormatter(record, prop, framework)
      }))
    }
  }

  return null
}
